import React, { Component } from 'react';
import { Link } from 'react-router-dom';

import Artwork from '../../model/artwork';
import Image from '../../model/image';
import { createLink, getElementFrom, getLangData } from '../../services/lang';

class ArtworkCard extends Component<ArtworkCardProps, ArtworkCardState> {

    state: ArtworkCardState = {
        imgSrc: '',
    };

    componentDidMount() {
        const artwork: Artwork = this.props.artworkData;
        // do not load images of invsibible images
        if (artwork.originalImages === undefined
            || artwork.originalImages?.length === 0) {
            this.setState({ imgSrc: '' });
            return;
        }
        const thumbImg: Image = artwork.smallImages[0];
        if (thumbImg.url === '') {
            this.setState({ imgSrc: '' });
            return;
        }
        this.setState({
            imgSrc: `${process.env.REACT_APP_STRAPI_HOST}${thumbImg.url}`,
        });
    }

    render() {

        const { artworkData } = this.props;
        const { imgSrc } = this.state;
        const langData = getLangData();

        let image;
        if (imgSrc === '') {
            image = <div className="d-flex justify-content-center align-items-center p-5">
                <p>
                    <span className="ti-image" /> {langData.meta.noImgAvailable}
                </p>;
            </div>;
        } else {
            image = <img className="card-img-top" src={this.state.imgSrc} alt={'#' + artworkData.regNum + ' ' + artworkData.title} />;
        }

        return (
            <div className="card w-100 mh-200" key={this.props.artworkData.regNum}>
                {image}
                <div className="card-img-overlay text-white d-flex align-items-end">
                    <div className="row">
                        <div className="col">
                            <p className="small mb-0">{artworkData.height} x {artworkData.width} cm</p>
                            <p className="small">{getElementFrom(langData.catalogue.typeOfObjectValues, artworkData.typeOfObject.toLowerCase())}</p>
                            <Link to={createLink("/artwork/" + artworkData.regNum)} className="lead text-white">
                                <span className="ti-arrow-right" /> #{artworkData.regNum} {artworkData.title}
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

type ArtworkCardProps = {
    artworkData: Artwork;
};

type ArtworkCardState = {
    imgSrc: string;
};

export default ArtworkCard;